import { boronClient, makeFormData } from "../../../api";
import { useBoronMutation } from "../../../hooks/http/useBoronMutation";

interface PostAnalyticsShareParams {
  studentId: string;
  message: string;
  image: Blob;
}

export const usePostAnalyticsShare = () => {
  return useBoronMutation<unknown, PostAnalyticsShareParams>(
    async ({ studentId, message, image }) => {
      return await boronClient.POST(
        "/api/v1/students/{student_id}/analytics/share",
        {
          params: { path: { student_id: studentId } },
          body: { message, image },
          bodySerializer: makeFormData,
        },
      );
    },
  );
};
